module.exports = __webpack_public_path__ + "static/media/facebook.616417cd.svg";